export enum TemplateTag {
    Energy,
    Water,
}
